module.exports = __webpack_public_path__ + "static/media/su_office.055bb9b5.png";